<template>
  <v-card v-if="selectedCount > 0" class="mb-4 pa-3 bg-blue-lighten-5 selection-toolbar">
    <div class="d-flex align-center justify-space-between flex-wrap">
      <div class="d-flex align-center gap-2">
        <strong>{{ selectedCount }}</strong>
        <span v-if="selectAllMode"> of {{ totalResults }} (all filtered)</span>
        <span v-else> selected</span>
        <v-btn
          v-if="!selectAllMode && totalResults > currentPageCount"
          variant="text"
          size="small"
          color="primary"
          :loading="loadingAllIds"
          @click="$emit('selectAll')"
        >
          Select all {{ totalResults }}
        </v-btn>
        <v-btn variant="text" size="small" @click="$emit('clearSelection')">Clear</v-btn>
      </div>
      <div class="d-flex gap-2 flex-wrap">
        <v-btn size="small" color="primary" @click="$emit('createGroup')">
          <v-icon size="small" class="mr-1">mdi-folder-plus</v-icon>
          Create Group
        </v-btn>
        <v-btn size="small" variant="outlined" @click="$emit('addToGroup')">
          <v-icon size="small" class="mr-1">mdi-folder-arrow-right</v-icon>
          Add to Group
        </v-btn>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn size="small" variant="outlined" v-bind="props">
              Bulk Actions
              <v-icon size="small" class="ml-1">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list density="compact">
            <v-list-item @click="$emit('bulkAction', 'suspend')">
              <v-list-item-title>Suspend</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('bulkAction', 'reactivate')">
              <v-list-item-title>Reactivate</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('bulkAction', 'terminate')">
              <v-list-item-title>Terminate</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('bulkAction', 'provision')">
              <v-list-item-title>Provision</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="hasSubclients" @click="$emit('bulkMove')">
              <v-list-item-title>Move to Subclient</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="$emit('bulkInventory')">
              <v-list-item-title>
                <v-icon size="small" class="mr-1">mdi-package-variant-plus</v-icon>
                Add to Inventory
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'ImsiToolbar',
  props: {
    selectedCount: {
      type: Number,
      default: 0
    },
    selectAllMode: {
      type: Boolean,
      default: false
    },
    totalResults: {
      type: Number,
      default: 0
    },
    currentPageCount: {
      type: Number,
      default: 0
    },
    loadingAllIds: {
      type: Boolean,
      default: false
    },
    hasSubclients: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'selectAll',
    'clearSelection',
    'createGroup',
    'addToGroup',
    'bulkAction',
    'bulkMove',
    'bulkInventory'
  ]
}
</script>

<style scoped>
.selection-toolbar {
  position: sticky;
  top: 140px;
  z-index: 10;
}
</style>
